import useFormStyles from "../hooks/useFormStyles";
import { InputAdornment, TextField } from "@material-ui/core";
import { IRoleSalaryConfigurationDto } from "@shared/services/salary-configuration/dtos/role-salary-configurations/roleSalaryConfigurationDto";
import { useFormik } from "formik";
import { FC } from "react";

interface SickDaysProps {
  formik: ReturnType<typeof useFormik<IRoleSalaryConfigurationDto>>;
}

const SickDaysForm: FC<SickDaysProps> = ({ formik }) => {
  const classes = useFormStyles();

  return (
    <div style= {{display: "flex", flexDirection:"column"}} className={classes.form}>
      <div>
        <TextField
          variant="outlined"
          className={classes.formControl}
          id="rateSick"
          name="rateSick"
          label="Стапка на боледување (по ден)"
          InputProps={{
            endAdornment: <InputAdornment position="start">мкд</InputAdornment>,
          }}
          type="number"
          value={formik.values.rateSick}
          onChange={formik.handleChange}
          error={formik.touched.rateSick && Boolean(formik.errors.rateSick)}
          helperText={formik.touched.rateSick && formik.errors.rateSick}
        />
      </div>
    </div>
  );
};

export default SickDaysForm;
